<template>
  <div class="page flex-col">
    <SiteHeader />
    <div class="box_34 flex-col">
      <div class="group_4 flex-col justify-end">
        <div class="text-wrapper_1">
          <span class="text_4">首页</span>
          <span class="text_5">&gt;新闻中心</span>
        </div>
        <div class="box_3 flex-col" v-if="newsData.lists && newsData.lists.length > 0">
          <span class="text_6">{{ formatDate(newsData.lists[0].create_time) }}</span>
          <div class="image_2_placeholder"></div>
          <router-link class="text_6_title" :to="'/news-detail?id=' + newsData.lists[0].id">{{ newsData.lists[0].title }}</router-link>
          <div class="group_5 flex-col" :style="{ backgroundImage: `url(${newsData.lists[0].image.replace(/\`/g, '')})` }"></div>
        </div>
      </div>
      <span class="paragraph_1" v-if="newsData.lists && newsData.lists.length > 0">
        {{ newsData.lists[0].title }}
        <br />
        &nbsp;
        <br />
        {{ newsData.lists[0].abstract || '新闻内容摘要' }}
      </span>
      <div class="box_35 flex-row">
        <span class="text_9">新闻动态</span>
        <div class="group_12 flex-col">
          <input ref="newsSearchInput" class="news-search-input" type="text" placeholder="请输入您感兴趣的内容" />
          <button class="news-search-btn" type="button" aria-label="搜索" @click="handleSearchClick"></button>
        </div>
      </div>
      <div v-for="(news, index) in newsData.lists" :key="news.id" class="news-item">
        <div class="box_36 flex-row justify-between">
          <div class="group_17 flex-col" :style="{ backgroundImage: `url(${news.image.replace(/\`/g, '')})` }"></div>
          <div class="box_37 flex-col">
            <span class="text_22">{{ news.title }}</span>
            <span class="text_23">
              {{ news.abstract || '新闻内容摘要' }}
            </span>
            <span class="text_24">{{ formatDate(news.create_time) }}</span>
            <router-link class="read-more-link" :to="'/news-detail?id=' + news.id">
              <div class="section_8 flex-row">
                <div class="image-text_21 flex-row justify-between">
                  <span class="text-group_9">阅读更多</span>
                  <img
                    class="thumbnail_1"
                    referrerpolicy="no-referrer"
                    src="./assets/img/SketchPnga42bd44cd0b975db1772339ea329271212c1dabdb94d66a0519920bf756f4de6.png"
                  />
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <img
          v-if="index < newsData.lists.length - 1"
          class="image_7"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng5115c7898d1532e9f93672281822d997edbd1b2149efd1d20ede676bfa6c669e.png"
        />
      </div>
      <div class="footer-spacing"></div>
    </div>
    <SiteFooter variant="news" />
  </div>
</template>
<script>
import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/SiteFooter.vue';

export default {
  name: 'NewsPage',
  components: {
    SiteHeader,
    SiteFooter
  },
  data() {
    return {
      newsData: {
        lists: [],
        count: 0,
        page_no: 1,
        page_size: 25
      }
    };
  },
  methods: {
    async fetchNewsData(keyword = '') {
      try {
        let url = '/api/article/lists?cid=3&page_no=&page_size=';
        if (keyword) {
          url += `&keyword=${encodeURIComponent(keyword)}`;
        }
        const response = await fetch(url);
        const data = await response.json();
        if (data.code === 1) {
          this.newsData = data.data;
          this.replaceImageDomain();
        }
      } catch (error) {
        console.error('Failed to fetch news data:', error);
      }
    },
    replaceImageDomain() {
      if (this.newsData && this.newsData.lists) {
        this.newsData.lists.forEach(item => {
          if (item.image) {
            item.image = item.image.replace(/vitalang\.36ysk\.com/g, 'www.haoronbio.com');
          }
        });
      }
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).replace(/\//g, '.');
    },
    handleSearchClick() {
      if (this.$refs.newsSearchInput) {
        const keyword = this.$refs.newsSearchInput.value;
        this.fetchNewsData(keyword);
      }
    }
  },
  mounted() {
    // 从URL查询参数中获取keyword
    const keyword = this.$route.query.keyword || '';
    if (keyword) {
      // 如果URL中有keyword参数，设置到搜索框
      if (this.$refs.newsSearchInput) {
        this.$refs.newsSearchInput.value = keyword;
      }
      this.fetchNewsData(keyword);
    } else {
      this.fetchNewsData();
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.rem.css" />
<style scoped>
.image_2_placeholder {
  width: 9.814rem;
  height: 1px;
  background-color: #e0e0e0;
  margin: 10px 0 10px 24.614rem;
}
.footer-spacing {
  height: 60px;
}
</style>
